import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeOfTime'
})
export class TypeOfTimePipe implements PipeTransform {

  transform(value: number): string {
    if (value === 0) {
      // Returning ' ' because 0 is the default value for enums in AL
      return ' ';
    }


    const name = TypeOfTime[value];

    if (!name) {
      return 'Undefined Status';
    }

    return name;
  }
}

enum TypeOfTime {
  Default = 0,
  Requested = 1,
  Booked = 2,
  Actual = 3,
  ETA = 4,
  Initial = 5,
  Closing = 6
}
